var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4987 27.75V2.25M30.1654 2.25H24.4987M30.1654 2.25V24.9167L27.332 27.75L24.4987 24.9167V2.25M30.1654 2.25V13.5833M24.4987 2.25V13.5833M24.4987 6.5H30.1654M1.83203 2.25V27.75H20.2487V2.25H1.83203Z",
    stroke: "#274137",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalSystemIcon);
export default __webpack_public_path__ + "static/media/journal_systemIcon.cf049ea60a7f6d5824d6a77149eed094.svg";
export { ForwardRef as ReactComponent };